module.exports = __webpack_public_path__ + "static/invoker-01-8e21b9c7c295310d21704f1dff9ee094.png";